module.exports = __webpack_public_path__ + "img/product-flag.d5fbbe94.svg";